// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

export const environment = {
  production: false,
  termsUrl: 'https://www-alpha.pklotcorp.com/terms',
  privacyUrl: 'https://www-alpha.pklotcorp.com/privacy',
  marketingConsentUrl: 'https://www-alpha.pklotcorp.com/marketing-consent',
  payTaipeiPolicyUrl: 'https://pklotcorp.com/pay_taipei_cardless_parking_terms',
  DOWNLOAD_AUTOPASS_LINK: 'autopassapp-alpha://open_main_page?need_login=false',
  amplitudeKey: '4828cc647704ab3de5932e7ba3055088',
} as const;
